var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-jumbotron',[_c('div',[_vm._v("Your Final Score was: "+_vm._s(_vm.numCorrect)+"/"+_vm._s(_vm.totalQuestions))])]),_c('b-button',{attrs:{"variant":"primary"},on:{"click":_vm.replay}},[_vm._v("Replay")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }